import store from "@/store"

class Multicast {
  constructor() {
    this.init = false
    this.player = null
    this.currentTime = 0
    this.IPTV_EVENT_TYPE = {
      PL_EMP_IPTV_EVENT_AUDIO_ONLY: 1,
      PL_EMP_IPTV_EVENT_VIDEO_ONLY: 2,
      PL_EMP_IPTV_EVENT_AUDIO_AND_VIDEO: 3,
      PL_EMP_IPTV_EVENT_NO_STREAMINPUT: 4,
      PL_EMP_IPTV_EVENT_STREAM_RECOVERED: 5
    }
  }
  _init = async () => {
    if (this.init) return true

    window.onbeforeunload = async () => {
      return await this.destroy()
    }

    _$.loader.createPlayer("object", {
      id: "pluginIPTV",
      class: "plugin",
      classid: "clsid:SAMSUNG-INFOLINK-SEF",
      style: "background:#000;"
    })

    this.player = document.getElementById("pluginIPTV")

    this.player.Open("IPTV", "1.000", "IPTV")
    this.player.OnEvent = (event, data1, data2) => this._onEvent(event, data1, data2)

    this.init = true

    return true
  }
  start = async () => {
    __._source.set(48)
    this.player.Execute("SIInit")
    return true
  }
  destroy = async () => {
    await this.stop()
    return true
  }

  play = async () => {
    const promise = await _$.progress.create(_$.progress.type.PLAY)
    if (promise.isResolved) return false

    this.closeSubtitle()

    const { width, height, x, y } = __.common.tvWindowMetrics

    let source = __.media.getSource()
    source = source.replace("udp", "rtp") + "|HW"
    if (store.state.live.channel?.groups.includes("Radio")) source = source.replace("|HW", "|HW|AUDIO_ONLY")
    /* Library Code */

    this.currentTime = 0

    this.player.Execute("SetTuneURL", source, 0)
    this.player.Execute("SetPlayerWindow", 0, 1.5 * x, 1.5 * y, 1.5 * width, 1.5 * height)

    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  stop = async () => {
    const promise = await _$.progress.create(_$.progress.type.STOP)

    /* Library Code */
    this.player.Execute("StopCurrentChannel", 0)
    this.player.Execute("FreeNowPlayingInfo", 0)
    _$.handler.emit("stopped")
    /* Library Code */

    _$.vue.$once(["mediaStopped", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  pause = async () => {
    return false
  }
  continue = async () => {
    return false
  }

  /* Control Helpers */
  isSeekable = async () => {
    return false
  }
  getDuration = async () => {
    return false
  }
  getPosition = async () => {
    return false
  }
  setPosition = async () => {
    return false
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    /* Library Code */
    __._device.pluginTV.Open("Window", "1.000", "Window")

    let subtitles = __._device.pluginTV.Execute("GetSubtitleInfo"),
      hasCurrent = __._device.pluginTV.Execute("GetCurrentSubtitle")

    __._device.pluginTV.Close()
    /* Library Code */

    const self = this
    subtitles = JSON.parse(subtitles).subtitle.map(function(subtitle) {
      const title = self._hex2a(subtitle.lang.toString(16))
      return { key: subtitle.index.toString(), value: title, selected: hasCurrent === subtitle.lang }
    })

    if (!subtitles.length) return false
    else subtitles.unshift({ key: "off", value: "None", selected: subtitles.find(item => item.selected) ? false : true })

    return subtitles
  }
  setSubtitle = async subtitle_pid => {
    if (subtitle_pid === "off") return this.closeSubtitle()

    __._device.pluginTV.Open("TV", "1.000", "TV")
    __._device.pluginTV.Execute("ShowCaption", "1")
    __._device.pluginTV.Close()

    __._device.pluginTV.Open("Window", "1.000", "Window")
    const res = __._device.pluginTV.Execute("ChangeSubtitle", parseInt(subtitle_pid, 10))
    __._device.pluginTV.Close()

    return res === 1 ? true : false
  }
  closeSubtitle = async () => {
    __._device.pluginTV.Open("TV", "1.000", "TV")
    __._device.pluginTV.Execute("ShowCaption", "0")
    __._device.pluginTV.Close()
    return true
  }

  getLanguages = async () => {
    /* Library Code */
    __._device.pluginTV.Open("Window", "1.000", "Window")

    let languages = JSON.parse(__._device.pluginTV.Execute("GetMultiAudioInfo")),
      hasCurrent = JSON.parse(__._device.pluginTV.Execute("GetCurrentAudioInfo"))

    __._device.pluginTV.Close()
    /* Library Code */

    const self = this
    languages = languages.items.map(function(language) {
      const title = self._hex2a(language.lang.toString(16)).replace("zz{", "org")
      return { key: language.index.toString(), value: title, selected: hasCurrent.lang === language.lang }
    })

    if (!languages.length) return false
    return languages
  }
  setLanguage = async language_pid => {
    __._device.pluginTV.Open("Window", "1.000", "Window")
    const res = __._device.pluginTV.Execute("ChangeAudioByIndex", parseInt(language_pid, 10))
    __._device.pluginTV.Close()

    return res === 1 ? true : false
  }
  _onEvent(event, data1) {
    switch (event) {
      case 1:
        _$.handler.emit("data_received", data1)
        break
      case 3:
        switch (parseInt(data1, 10)) {
          case this.IPTV_EVENT_TYPE.PL_EMP_IPTV_EVENT_AUDIO_ONLY:
          case this.IPTV_EVENT_TYPE.PL_EMP_IPTV_EVENT_VIDEO_ONLY:
          case this.IPTV_EVENT_TYPE.PL_EMP_IPTV_EVENT_AUDIO_AND_VIDEO:
          case this.IPTV_EVENT_TYPE.PL_EMP_IPTV_EVENT_STREAM_RECOVERED:
            _$.handler.emit("playing")
            break
          case this.IPTV_EVENT_TYPE.PL_EMP_IPTV_EVENT_NO_STREAMINPUT:
            if (__.media.status !== "playing") _$.handler.emit("error")
            break

          default:
            _$.handler.emit("playing")
            break
        }
        break
      default:
        break
    }
  }
  _hex2a(hexx) {
    var hex = hexx.toString() //force conversion
    var str = ""
    for (var i = 0; i < hex.length; i += 2) str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
    return str
  }
}

export default Multicast
